import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const purchaseOrderDeleteAtom = createMutationAtomFactory(
  'trade.purchaseOrderDelete',
  (params: { id: string }) => ({
    tradePurchaseOrderDelete: {
      __args: {
        id: params.id,
      },
    },
  }),
);
